import { render } from "./UpdateCalculationPrice.vue?vue&type=template&id=58618618&scoped=true&ts=true"
import script from "./UpdateCalculationPrice.vue?vue&type=script&lang=ts"
export * from "./UpdateCalculationPrice.vue?vue&type=script&lang=ts"

import "./UpdateCalculationPrice.vue?vue&type=style&index=0&id=58618618&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58618618"]])

export default __exports__